import { UserSimplified } from "./UserSimplified";
import { z } from "zod";

export const TopPick = z.object({
  kudos_count: z.number(),
  user: UserSimplified,
});

export type TopPick = z.infer<typeof TopPick>;
